<div>
  <div class="d-flex tl-comments">
    <!-- Profile Picture -->
    <div [routerLink]="['/', commentState?.comment?.author?.handle]">
      <img [src]="commentState?.comment?.author?.photoURL?.trim() || './assets/images/profile.jpg'" alt="avatar"
           class="tl-profile-c pr-cursor">
    </div>

    <!-- Name -->
    <div>
      <span class="tl-name pr-cursor"
            [routerLink]="['/', commentState?.comment?.author?.handle]">{{commentState?.comment?.author?.name}}</span>&nbsp;
      <span class="tl-date">
        <i class="fas fa-clock mr-1"></i>
        {{commentState?.comment?.lastEdited | postTime}}
      </span>
      <div class="tl-replies d-flex justify-content-between">

        <div *ngIf="commentState?.comment?.images as images">
          <img *ngFor="let i  of images" [src]="i.url">
        </div>


        <markdown ngPreserveWhitespaces class="align-self-center">
          {{showMarkDown(commentState?.comment?.body)}}
        </markdown>

        <!-- Actions -->
        <button mat-icon-button [matMenuTriggerFor]="actions" class="comment-options align-self-center">
          <mat-icon class="text-muted">more_horiz</mat-icon>
        </button>
        <mat-menu #actions="matMenu">
          <button mat-menu-item (click)="deleteComment()"
                  *ngIf="currentUser && currentUser.ID === commentState.comment.author.ID">
            <mat-icon>delete</mat-icon>
            <span>Delete</span>
          </button>
          <button mat-menu-item (click)="reportComment()"
                  *ngIf="currentUser && currentUser.ID != commentState.comment.author.ID">
            <mat-icon>report_problem</mat-icon>
            <span>Report</span>
          </button>
        </mat-menu>
      </div>
      <div class="d-flex justify-content-between">
        <div>
          <!-- ******** We need to show vote status by using default colors for then specific colors when a vote has been made ***** -->
          <button mat-icon-button aria-label="Upvote" matTooltip="Upvote" (click)="upVoteComment()"
                  *ngIf="commentState?.comment?.myVote === 'NONE' || commentState?.comment?.myVote !== 'UPVOTE'">
            <mat-icon fontSet="material-icons-outlined" class="small-icons">thumb_up</mat-icon>
          </button>
          <button mat-icon-button aria-label="Upvote" color="primary" matTooltip="Upvote" (click)="upVoteComment()"
                  *ngIf="commentState?.comment?.myVote === 'UPVOTE'">
            <mat-icon fontSet="material-icons-outlined" class="small-icons">thumb_up</mat-icon>
          </button>
          <small>{{commentState?.comment?.votes?.upVotes - commentState?.comment?.votes?.downVotes}}</small>
          <button mat-icon-button aria-label="Downvote" matTooltip="Downvote" (click)="downVoteComment()"
                  *ngIf="commentState?.comment?.myVote === 'NONE' || commentState?.comment?.myVote !== 'DOWNVOTE'">
            <mat-icon fontSet="material-icons-outlined" class="small-icons">thumb_down</mat-icon>
          </button>
          <button mat-icon-button aria-label="Downvote" color="accent" matTooltip="Downvote"
                  *ngIf="commentState?.comment?.myVote === 'DOWNVOTE'">
            <mat-icon fontSet="material-icons-outlined" class="small-icons">thumb_down</mat-icon>
          </button>
          <!-- Comment Replies Hidden Until They are Implemented -->
          <button mat-icon-button aria-label="Reply" matTooltip="Reply" (click)="showReplyComment()">
            <mat-icon>reply</mat-icon>
          </button>
          <small>{{commentState?.comment?.replyCount}}</small>
        </div>
      </div>
    </div>
  </div>
  <div class="ml-5">

    <reply-comment-section [currentUser]="currentUser" [commentState]="commentState"
                           (createReplyCommentEvent)="createReplyComment($event)"
                           (hideReplyCommentsEvent)="hideReplyComments()"
                           (loadMoreReplyCommentsEvent)="loadMoreReplyComments()"
                           (deleteReplyCommentEvent)="deleteReplyComment($event)"
                           (upVoteReplyCommentEvent)="upVoteReplyComment($event)"
                           (downVoteReplyCommentEvent)="downVoteReplyComment($event)">
    </reply-comment-section>

  </div>
</div>
